import React, { useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ApplicationInfoTabsContext } from 'src/features/Advisors/Applications/SummaryMortgage/commonContext';
import { useStyles } from 'src/features/Advisors/Applications/SummaryMortgage/SummaryMortgageLanding.styles'
import Button from 'src/components/Buttons/Button';
import ChevronLeftIcon from 'src/assets/icons/chevron-left.svg';
import { canGuard } from 'src/features/RBAC/Can';

import { PermissionContext } from 'src/features/RBAC/PermissionContext';
import { ADVISOR_ONE_LOAN_URLA_UPDATE } from 'src/features/RBAC/Rules/permissionData';
import Box from '@mui/material/Box';

interface Props {
  showModal: boolean;
  modalTitle: any;
  toggleModal: any;
  modalContent: any;
  onSubmit?: any;
  disabled?: any;
  showGoBack?: any;
  modalSize?: any;
  contentStyles?: any;
  titleStyles?: any;
  buttonText?: any;
  buttonVariant?: any;
  onCancel?: () => void;
  savableModal?: boolean;
  hideActions?: boolean;
}
type CombinedProps = Props
const DataModal: React.FC<CombinedProps> = (props: CombinedProps) => {
  const {
    showModal,
    modalTitle,
    onCancel,
    toggleModal,
    modalContent,
    onSubmit,
    disabled,
    showGoBack,
    modalSize,
    contentStyles,
    titleStyles,
    buttonText,
    buttonVariant,
    savableModal,
    hideActions
  } = props;

  const {
    popupSubmitting,
    saveDisabled
  } = useContext(ApplicationInfoTabsContext)
  const { permissions } = useContext(PermissionContext);
  const hasUserSaveAccess = canGuard(permissions, ADVISOR_ONE_LOAN_URLA_UPDATE) || savableModal;

  const renderButtons = () => {
    if (hasUserSaveAccess) {
      return (
        <DialogActions className={classes.btnActionContainer}>
          <Button
            px={40}
            py={12}
            text='Cancel'
            variant='outlined'
            onClick={onCancel}
            className={classes.footerBtn}
            data-test-id={"modal-cancel-button"}
          />
          <Button
            px={40}
            py={12}
            text='Save'
            loading={popupSubmitting}
            onClick={onSubmit}
            className={classes.footerBtn}
            disabled={saveDisabled || disabled}
            data-test-id={"modal-save-button"}
          />
        </DialogActions>
      )
    }
    return (<DialogActions className={classes.btnActionContainer}>
      <Button
        px={40}
        py={12}
        text={buttonText}
        variant={buttonVariant}
        onClick={toggleModal}
        className={classes.footerBtn}
      />
    </DialogActions>)
  }

  const classes = useStyles()
  return (
    <Dialog open={showModal} onClose={toggleModal} maxWidth={modalSize ? modalSize : 'lg'} fullWidth>
      <Box className={classes.headerWrapper}>
      {showGoBack && <Button
          px={30}
          py={6}
          text='Go Back'
          variant='text'
          onClick={toggleModal}
          startIcon={<ChevronLeftIcon />}
          className={classes.goBackBtn}
        />}
        <DialogTitle className={classes.dataDialogTitle} sx={titleStyles}>
          {modalTitle}
        </DialogTitle>
      </Box>
      <DialogContent sx={contentStyles}>
        {modalContent}
      </DialogContent>
      {!hideActions && renderButtons()}
    </Dialog>
  )
}
export default DataModal;
